module.exports = __webpack_public_path__ + "assets/images/scrolly-network/big.svg?v=cf87cbc6";